/* eslint-disable */
import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  agreements: [],
  selectedAgreement: null,
  contractBlocks: [],
};

export default (state = initialState, action) => {
  let index;

  switch (action.type) {
    case actionTypes.AGREEMENT_GET_REQUEST:
    case actionTypes.AGREEMENT_CREATE_REQUEST:
    case actionTypes.AGREEMENT_UPDATE_REQUEST:
    case actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.AGREEMENTS_GET_ERROR:
      return { ...state, status: action.type, agreements: [] };

    case actionTypes.AGREEMENTS_GET_SUCCESS:
      return { ...state, status: action.type, agreements: action.agreements };

    case actionTypes.AGREEMENT_GET_ERROR:
    case actionTypes.AGREEMENT_CREATE_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        selectedAgreement: null,
      };

    case actionTypes.AGREEMENT_GET_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedAgreement: action.agreement,
      };

    case actionTypes.AGREEMENT_SELECT:
      return {
        ...state,
        status: action.type,
        selectedAgreement: action.agreement,
        contractBlocks: [],
      };

    case actionTypes.AGREEMENT_CREATE_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedAgreement: action.agreement,
        agreements: state.agreements.concat(action.agreement),
      };

    case actionTypes.AGREEMENT_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.agreement.id))(
        state.agreements
      );
      if (index === -1) {
        const agreement = {
          ...action.agreement,
          deals: state.selectedAgreement ? state.selectedAgreement.deals : [],
          sentences: state.selectedAgreement
            ? state.selectedAgreement.sentences
            : [],
        };
        return {
          ...state,
          status: action.type,
          selectedAgreement: agreement,
          agreements: state.agreements.concat(action.agreement),
        };
      } else {
        let { deals, sentences } = state.agreements[index];
        state.agreements[index] = {
          ...action.agreement,
          deals,
          sentences,
        };
        const agreement = {
          ...action.agreement,
          deals: state.selectedAgreement ? state.selectedAgreement.deals : [],
          sentences: state.selectedAgreement
            ? state.selectedAgreement.sentences
            : [],
        };
        return {
          ...state,
          status: action.type,
          selectedAgreement: agreement,
          agreements: [...state.agreements],
        };
      }

    case actionTypes.AGREEMENT_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.agreementId, 10)))(
        state.agreements
      );

      if (index !== -1) {
        return {
          ...state,
          status: action.type,
          selectedAgreement: null,
          agreements: R.remove(index, 1, state.agreements),
        };
      } else {
        return { ...state, status: action.type, selectedAgreement: null };
      }

    case actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_ERROR:
      return { ...state, status: action.type, contractBlocks: [] };

    case actionTypes.AGREEMENT_CONTRACT_BLOCKS_GET_SUCCESS:
    case actionTypes.AGREEMENT_CONTRACT_BLOCKS_SAVE:
      return {
        ...state,
        status: action.type,
        contractBlocks: action.contractBlocks,
      };

    case actionTypes.AGREEMENT_CONTRACT_BLOCK_SAVE_SUCCESS:
      let { contractBlocks } = state;
      index = R.findIndex(R.propEq('id', action.contractBlock.id))(
        contractBlocks
      );

      if (index === -1) {
        return {
          ...state,
          status: action.type,
          contractBlocks: contractBlocks.concat(action.contractBlock),
        };
      } else {
        contractBlocks[index] = action.contractBlock;
        return { ...state, status: action.type, contractBlocks };
      }

    case actionTypes.AGREEMENT_SENTENCE_CREATE_SUCCESS:
    case actionTypes.AGREEMENT_SENTENCE_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.agreementSentence.agreement))(
        state.agreements
      );
      let agreements = [...state.agreements];
      let selectedAgreement = state.selectedAgreement;

      if (index !== -1) {
        const agreement = state.agreements[index];
        const sentences = agreement.sentences || [];
        const index2 = R.findIndex(R.propEq('id', action.agreementSentence.id))(
          sentences
        );

        if (index2 === -1) {
          sentences.push(action.agreementSentence);
        } else {
          sentences[index2] = action.agreementSentence;
        }

        state.agreements[index] = { ...agreement, sentences: [...sentences] };
        agreements = [...state.agreements];
      }

      if (
        state.selectedAgreement &&
        state.selectedAgreement.id === action.agreementSentence.agreement
      ) {
        const agreement = state.selectedAgreement;
        const sentences = agreement.sentences || [];
        const index2 = R.findIndex(R.propEq('id', action.agreementSentence.id))(
          sentences
        );

        if (index2 === -1) {
          sentences.push(action.agreementSentence);
        } else {
          sentences[index2] = action.agreementSentence;
        }

        selectedAgreement = {
          ...agreement,
          sentences: [...sentences],
        };
      }

      return { ...state, agreements, selectedAgreement };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/agreements.js